import { Link } from "react-router-dom";
import { Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";

import slide1 from "../assets/grey swing corner 900mm.webp";
import slide2 from "../assets/ms-2d-hydraulick-hinge.jpeg";
import slide3 from "../assets/pocket-door -slide.webp";
import slide4 from "../assets/grey-slimbox.webp";
import slide5 from "../assets/partition-basket.webp";
import slide6 from "../assets/soft-close.webp";

const products = [
  {
    id: 1,
    img: slide1,
    name: "Grey Swing Corner",
    path: "/corner-solutions",
  },
  {
    id: 2,
    img: slide2,
    name: "2D Hydraulic Hinges",
    path: "/cabinet-hinges",
  },
  {
    id: 3,
    img: slide3,
    name: "Pocket Door System",
    path: "/telescopic-channel",
  },
  {
    id: 4,
    img: slide4,
    name: "Slim Box Drawer",
    path: "/slim-box",
  },
  {
    id: 5,
    img: slide5,
    name: "Partition Basket",
    path: "/multiuseBasket",
  },
  {
    id: 6,
    img: slide6,
    name: "Soft Close System",
    path: "/telescopic-channel",
  },
];

export default function Slide() {
  return (
    <section className="slm-swiper-section">
      <div className="slm-title-wrap">
        <span className="slm-subtitle">
          Premium Hardware Collection
        </span>

        <h2 className="slm-swiper-title">
          Discover Our <span>Latest Products</span>
        </h2>
      </div>

    <Swiper
  modules={[Navigation, Autoplay]}
  navigation
  loop
  speed={700}
  grabCursor={true}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  }}
  breakpoints={{
    0: {
      slidesPerView: 1,
      spaceBetween: 15,
    },

    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },

    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  }}
>
        {products.map((item) => (
          <SwiperSlide key={item.id}>
            <Link
              to={item.path}
              className="slm-product-link"
            >
              <div className="slm-product-card">
                <div className="slm-product-img">
                  <img
                    src={item.img}
                    alt={item.name}
                    width="320"
                    height="320"
                    loading="lazy"
                    decoding="async"
                  />
                </div>

                <div className="slm-product-content">
                  <h3>{item.name}</h3>

                  <span className="slm-view-btn">
                    View Product →
                  </span>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}